// src/components/modals/DetailsModal/WordModalTabs/DetailsTab.js
import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import GlassyBadge from '../../../common/GlassyBadge';

const DetailsTab = ({ senses = [] }) => {
  if (!senses || senses.length === 0) {
    return (
      <div className="p-6 text-center py-8">
        <BookOpenIcon className="h-12 w-12 text-content-secondary/40 mx-auto mb-3" />
        <p className="text-content-secondary">No detailed senses available for this word.</p>
      </div>
    );
  }

  return (
    <div className="relative p-6">
      {/* Very subtle colorful glassy background bubbles - positioned on the right */}
      <div className="fixed inset-0 pointer-events-none" style={{ zIndex: -1 }}>
        <div className="relative w-full h-full overflow-hidden">
          <div
            className="absolute rounded-full backdrop-blur-sm border border-white/5"
            style={{
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.06), rgba(59, 130, 246, 0.04))', // purple to blue
              width: '120px',
              height: '120px',
              top: '8%',
              right: '5%',
              boxShadow: '0 8px 32px rgba(139, 92, 246, 0.02)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
          </div>
          <div
            className="absolute rounded-full backdrop-blur-sm border border-white/5"
            style={{
              background: 'linear-gradient(45deg, rgba(236, 72, 153, 0.05), rgba(139, 92, 246, 0.03))', // pink to purple
              width: '80px',
              height: '80px',
              top: '40%',
              right: '8%',
              boxShadow: '0 8px 32px rgba(236, 72, 153, 0.02)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
          </div>
          <div
            className="absolute rounded-full backdrop-blur-sm border border-white/5"
            style={{
              background: 'linear-gradient(225deg, rgba(59, 130, 246, 0.04), rgba(236, 72, 153, 0.03))', // blue to pink
              width: '60px',
              height: '60px',
              bottom: '15%',
              right: '12%',
              boxShadow: '0 8px 32px rgba(59, 130, 246, 0.01)',
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-30 rounded-full" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative">
        <div className="space-y-6 divide-y divide-border">
          {senses.map((sense, index) => (
            <div key={index} className={index > 0 ? 'pt-6' : ''}>
              <div className="flex">
                <div className="mr-4 pt-2">
                  <div 
                    className="h-3 w-3 rounded-full border-2 border-white/20 backdrop-blur-sm"
                    style={{
                      background: 'var(--color-secondary)',
                      boxShadow: '0 2px 8px var(--color-secondary)40'
                    }}
                  ></div>
                </div>

                <div className="flex-grow">
                  <p className="font-semibold text-base text-content-primary leading-relaxed">
                    {sense.translation.join('; ')}
                  </p>

                  {(sense.parts_of_speech?.length > 0 || sense.tags_jisho?.length > 0) && (
                    <div className="mt-3 space-y-3">
                      {sense.parts_of_speech?.length > 0 && (
                        <p className="text-sm text-content-secondary/80 italic">
                          {sense.parts_of_speech.join(', ')}
                        </p>
                      )}

                      {sense.tags_jisho?.length > 0 && (
                        <div className="flex flex-wrap gap-2">
                          {sense.tags_jisho.map((tag) => (
                            <GlassyBadge
                              key={tag}
                              color="purple"
                              size="sm"
                            >
                              {tag}
                            </GlassyBadge>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;